import { render } from "./ProfileChangeEmail.vue?vue&type=template&id=14080bb8"
import script from "./ProfileChangeEmail.vue?vue&type=script&lang=js"
export * from "./ProfileChangeEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__